<template>
  <div
    class="u-display-flex u-width--100% u-justify-content-center u-align-items-center u-flex-direction-column"
    :class="{ 'u-margin-top u-margin-bottom': !noMargin }"
  >
    <span class="loader primary-loading small-loader"></span>
    <small v-if="message" class="u-margin-top">{{ message }}</small>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: {
    noMargin: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "",
    },
  },
};
</script>

<style></style>
